import {FC, ReactNode, useEffect, useRef} from 'react';

type PropsType = {
  children?: ReactNode;
  title: string | undefined;
  prevailOnUnmount?: boolean;
};

export const TitlePage: FC<PropsType> = ({
  children,
  title = '',
  prevailOnUnmount = false,
}) => {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = defaultTitle.current;
      }
    },
    [prevailOnUnmount],
  );

  return <>{children}</>;
};
